import React from 'react';
import { Box, Divider, Typography } from '@mui/material';


import { makeStyles } from 'tss-react/mui';


const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(5, 10),
    backgroundColor: theme.palette.common.white,

  },
  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontWeight: 500,
  },
}));


export type AssessmentReviewContainerProps = {
  title: string;
  sentBy?: string;
};


export const AssessmentReviewContainer: React.FC<AssessmentReviewContainerProps> = (props) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.title}>
        <Typography>{props.title}</Typography>
        {props.sentBy && <Typography>sent by {props.sentBy}</Typography>}
      </Box>
      <Divider />
      {props.children}
    </Box>
  );
};
